import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M15.132 16.192L6.47 24.854l1.06 1.061 8.662-8.662 8.663 8.662 1.06-1.06-8.662-8.663 8.662-8.662-1.06-1.06-8.663 8.662L7.53 6.47 6.47 7.53l8.662 8.662z" }));
export {
  o as ReactComponent
};
